export const environment = {
    production: false,
    env: {
        name:"QA",
        banner: "QA Environment"
    },
    logLevel: 'DEBUG',
    apiServer:  {
        webSocketlUrl: "wss://portalserver-qa.acimobills.com/portal",
        portalUrl: "https://portalserver-qa.acimobills.com/portal/api",
        authServerUrl: "https://portalserver-qa.acimobills.com/auth/api",
        rtpnUrl: "https://qa.walletron.com/rtpn/api"         
    },
    appSetting: {
    },
    brandMigration: {
        sourceRegions: ["uat", "demo", "client2prod", "mbprod", "mobills2prod", "wuprod"],
        targetRegions: ["qa"]
    }
};